import React from 'react';
import { useTranslation } from 'react-i18next';

const Imprint: React.FC = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 min-h-[calc(100vh-200px)]">
      {/* Meta */}
      <div className="flex items-start justify-between mb-4 gap-4">
        <h1 className="text-3xl font-bold flex-shrink">{t('imprint.title')}</h1>
        <div className="flex items-center gap-2 flex-shrink-0 ml-auto">
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded whitespace-nowrap">{t('imprint.lastUpdated')}</span>
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded whitespace-nowrap">{t('imprint.version')}</span>
        </div>
      </div>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('imprint.company.title')}</h2>
      <p className="text-gray-700">{t('imprint.company.name')}</p>
      <p className="text-gray-700">{t('imprint.company.address')}</p>
      <p className="text-gray-700">{t('imprint.company.email')}</p>
      <p className="text-gray-700">{t('imprint.company.register')}</p>
      <p className="text-gray-700">{t('imprint.company.ceo')}</p>
      <p className="text-gray-700">{t('imprint.company.vat')}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('imprint.contact.title')}</h2>
      <p className="text-gray-700">{t('imprint.contact.text')}</p>
    </div>
  );
};

export default Imprint;
